import { connect, FormikContext } from 'formik'

interface FormikConnect {
  // Needs to be `any`, otherwise formik's `connect` complains about type
  // mismatch.
  <Props extends { formik: FormikContext<any> }>(
    component: React.ComponentType<Props>,
  ): React.ComponentType<Omit<Props, 'formik'>>
}

/**
 * Formik provides a `connect` function that injects a `formik` prop into your
 * component.
 * This works well, but it doesn't remove the `formik` prop from the
 * component's props, so when you try to use `<YourComponent />`, it complains
 * that you're not passing a `formik` prop.
 * This helper works around that.
 */
const formikConnect = connect as FormikConnect

export default formikConnect
